import { GHGEmissionsReportEntry } from '@/hooks'
import { faker } from '@faker-js/faker'

const generateEmissionValue = () => ({
    type: faker.helpers.arrayElement(['CO2EEF', 'CO2E'] as const),
    uom: 'CO2e MT',
    value: faker.number.int({ min: 50, max: 300 }),
})

export const generateGHGEmissionsItem = () => {
    const entry: GHGEmissionsReportEntry = {
        facilityName: faker.company.name(),
        commodityType: faker.commerce.product(),
        uom: faker.helpers.arrayElement(['kWh', 'Therms']),
        consumption: faker.number.int({ min: 1000, max: 5000 }),
        scope1Direct: [generateEmissionValue()],
        scope2LocationBased: [generateEmissionValue()],
        scope2MarketBased: [generateEmissionValue()],
        source: faker.company.name(),
    }

    return entry
}

export const generateGHGEmissionsResponse = (count = 20) => {
    const items = Array.from({ length: count }, () =>
        generateGHGEmissionsItem()
    )
    const total = items.length

    return {
        items,
        total,
    }
}
